import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/ask/point.png';
import _imports_1 from '@/assets/componentImg/arrow.png';

const _withScopeId = n => (_pushScopeId("data-v-57252f37"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-wrap"
};
const _hoisted_2 = {
  class: "name"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "point-wrap"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "title"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

import composition from '@/composition';
import { ref } from '@vue/reactivity';
export default {
  props: {
    item: Object,
    type: String // -1 友圈列表 0问吧列表 1回答页面 2详情页面

  },

  setup(__props) {
    const props = __props;
    const {
      CImage,
      formatTime,
      openApp,
      openWebPage,
      headPoster
    } = composition();
    const element = ref(false);

    if (props.type <= 0) {
      element.value = {
        name: props.item.memberNickname,
        content: props.item.content,
        time: props.item.createTime,
        photo: props.item.memberPhoto
      };
    } else {
      if (props.item.handleContent.length > 0) {
        element.value = {
          name: props.item.handlePoster.professor.name,
          content: props.item.handleContent,
          appellation: props.item.handlePoster.professor.appellation,
          photo: props.item.handlePoster.professor.face
        };
      }
    }

    const openTag = tag => {
      openWebPage(tag.type == 'ASK' ? 'askbar/index.html' : 'topic/index.html', tag.id);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [element.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['content-wrap', __props.type <= 0 ? '' : 'answer-wrap'])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(CImage), {
        class: "head-img",
        poster: _unref(headPoster)(__props.type, __props.item)
      }, null, 8, ["poster"]), _createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(element.value.name) + " ", 1), element.value.time ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(formatTime)(__props.item.createTime)), 1)) : _createCommentVNode("", true), element.value.appellation ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(element.value.appellation), 1)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(__props.item.bonusPoints) + "积分", 1)], 512), [[_vShow, __props.type == 0]])]), _createElementVNode("p", {
        class: _normalizeClass(['content', __props.type >= 1 ? 'ellipsis-content' : '', __props.type == 2 ? 'detail-content' : ''])
      }, [_createTextVNode(_toDisplayString(element.value.content), 1), __props.type == -1 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.item.tags, (tag, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: "tag",
          key: index,
          onClick: $event => openTag(tag)
        }, " #" + _toDisplayString(tag.name), 9, _hoisted_7);
      }), 128)) : _createCommentVNode("", true)], 2), __props.type == 2 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "open-btn",
        onClick: _cache[0] || (_cache[0] = $event => _unref(openApp)())
      }, "打开佛山+查看详细回答")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), __props.type == 2 && __props.item.tags.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "topic-wrap",
        onClick: _cache[1] || (_cache[1] = $event => openTag(__props.item.tags[0]))
      }, [_createElementVNode("p", _hoisted_8, "原话题：" + _toDisplayString(__props.item.tags[0].name), 1), _hoisted_9])) : _createCommentVNode("", true)], 64);
    };
  }

};